<template>
  <div>
    <v-alert
      v-if="errorMessage"
      :value="!!errorMessage"
      :dismissible="dismissible"
      color="error"
      icon="warning"
      transition="scale-transition"
    >
      {{ errorMessage }}
    </v-alert>
  </div>
</template>

<script>
export default {
  props: {
    errorMessage: {
      type: [String, Boolean],
      default: '',
    },
    dismissible: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped></style>
